import { useLingui } from "@lingui/react/macro";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { Search } from "lucide-react";
import { useMemo, useState } from "react";

import { CustomECGStatement, DefaultECGStatement } from "../../../api";
import {
  PopoverContent,
  PopoverTrigger,
} from "../../../components/ui-kit/popover";
import styles from "../../../components/ui-kit/tables/cells/cell-json.module.css";
import { SimpleTable } from "../../../components/ui-kit/tables/simple-table";

export function CellAnnotationDetails(props: {
  code: string;
  codeDetails: DefaultECGStatement | CustomECGStatement;
}) {
  const { t } = useLingui();
  const [open, setOpen] = useState(false);

  const rows = useMemo(
    () =>
      Object.entries(props.codeDetails).map(([key, value]) => ({ key, value })),
    [props.codeDetails],
  );

  return (
    <div className={styles.root}>
      <div>{props.code}</div>
      <div className="grow" />

      <PopoverPrimitive.Root open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" className={styles.button}>
            <Search size={14} />
          </button>
        </PopoverTrigger>

        <PopoverPrimitive.Portal>
          <PopoverContent>
            <SimpleTable
              rows={rows}
              itemKeyField="key"
              columns={[
                {
                  header1: t`Property`,
                  cell: (row) => prettyKey(row.key),
                },
                {
                  header1: t`Value`,
                  cell: (row) =>
                    typeof row.value === "string"
                      ? row.value
                      : JSON.stringify(row.value),
                },
              ]}
            />
          </PopoverContent>
        </PopoverPrimitive.Portal>
      </PopoverPrimitive.Root>
    </div>
  );
}

function prettyKey(key: string) {
  const pretty = key.replace(/_/g, " ");
  return pretty.charAt(0).toUpperCase() + pretty.slice(1);
}
